import { render, staticRenderFns } from "./GuppyChatNotifyMessage.vue?vue&type=template&id=2650560c&"
import script from "./GuppyChatNotifyMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatNotifyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports